import { requestBuilder } from '../../http/RequestBuilder';
import type { InterestTotalsResponseDto } from './types';

export const useGetInterestTotals = requestBuilder.query<
    InterestTotalsResponseDto,
    { date: string },
    Error
>({
    endpoint: ({ date }) => `/api/admin/bank-ops/interest-totals/${date}`,
    queryKey: ({ date }) => `/api/admin/bank-ops/interest-totals/${date}`,
});
